module.exports = __webpack_public_path__ + "static/media/user-placeholder.25ef3ec7.svg";